#import "@core/schema/fragments/ContentBlockFull.graphql"

query (
  $id: ID!
) {
  getMemberPostContent(
    id: $id
  ) {
    ...ContentBlockFull
  }
}
